import { ISetPaginationPayload } from '../actions/pagination';
import {IApiQueryData, IProductReviewActionState} from '../interfaces';
import {PARAM_PAGE, PARAM_RATING} from '../constants';

export const doSetRating = (state: IProductReviewActionState, payload: ISetPaginationPayload): IProductReviewActionState => {
    const newApiQueryData: IApiQueryData = {
        ...state.apiQueryData,
        [PARAM_RATING]: payload[PARAM_RATING],
        [PARAM_PAGE]: '1',
    };

    return {
        ...state,
        productReviews: [],
        isPageLoading: true,
        apiQueryData: newApiQueryData,
    };
};
